import { constants } from "shared/constants";
import { CompanyBasedSectionReports } from "./CompanyBasedSectionReports";

const customersSectionReports = [constants.v360ReportCodes.intermediary.customersSection.customers];

class SalesOverviewSectionReports extends CompanyBasedSectionReports {
    /**
     *
     */
    constructor() {
        super(customersSectionReports, customersSectionReports);
    }
}

export default new SalesOverviewSectionReports();
